import { render, staticRenderFns } from "./AutocompleteFacebook.vue?vue&type=template&id=2e8c3a65"
import script from "./AutocompleteFacebook.vue?vue&type=script&lang=js"
export * from "./AutocompleteFacebook.vue?vue&type=script&lang=js"
import style0 from "./AutocompleteFacebook.vue?vue&type=style&index=0&id=2e8c3a65&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports